import { cycleCountIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const bulkDeleteCycleCounts = unaryRpc({
  name: "bulkDeleteCycleCounts" as const,
  input: z.object({
    cycleCountIds: z.array(cycleCountIdFormat.schema).min(1).max(100),
  }),
  output: z.object({ deletedCount: z.int() }),
});
